<script setup lang="ts">
const { toggle, isOpen } = useNavigation();
const { user: userInfo } = useUser();
const { routes } = userInfo.value;
</script>

<template>
    <div class="h-full">
            <div
                class="relative h-full bg-white"
                :class="[
                     isOpen ? 'w-nav-extended' : 'w-nav-collapsed',
                     'transition-all duration-300 ease-out'
                ]"
            >
                <!-- toggle -->
                <button
                    :class="[
                      'absolute right-0 z-[1] hidden md:block',
                      'translate-x-1/2 translate-y-[2.75rem]',
                      'transition-transform duration-300 ease-out',
                      'rounded-full p-1',
                      'border border-black',
                      'bg-white',
                      'hover:shadow-[3px_3px_0px_0px_rgb(0,0,0,1)]',
                    ]"
                    title="Navigation Ein- und Ausklappen"
                    @click="toggle"
                >
                    <span
                        :class="`block ${
                            isOpen ? 'rotate-180' : '-rotate-0'
                        }`"
                    >
                        <BaseIcon icon-name="arrow-to-right" size="large" />
                    </span>
                </button>

                <div
                    :class="`overflow-x-hidden overflow-y-auto overscroll-contain border-r border-gray-900 h-full flex flex-col p-4 ${
                        !isOpen && 'items-center'
                    }`"
                >
                    <!-- header -->
                    <NuxtLink
                        :class="[
                            'hidden md:block',
                            'shrink-0',
                            !isOpen && 'mx-auto',
                            'min-h-[2.5rem]',
                        ]"
                        :to="routes.dashboard"
                        external
                    >
                        <!-- brand -->
                        <div
                            :class="[
                                !isOpen
                                    ? 'flex items-center justify-center'
                                    : '',
                            ]"
                        >
                            <BaseLogo
                                :variant="isOpen ? 'logo' : 'pictogram'"
                                :class="isOpen ? '' : 'size-10'"
                                title="karriere.at Logo"
                            />
                        </div>
                    </NuxtLink>
                    <slot />
                </div>
            </div>
    </div>
</template>
